export const DEFAULT_LOCALE = "en"
export const ALTERNATIVE_LOCALES = ["de"] as const
export type AlternativeLocale = (typeof ALTERNATIVE_LOCALES)[number]
export const LOCALES = [DEFAULT_LOCALE, ...ALTERNATIVE_LOCALES] as const
export type Locale = (typeof LOCALES)[number]
